import { type LoaderFunction, redirect } from 'react-router-dom';
import { Paths } from '@src/paths.ts';
import authenticationService from '@src/api/services/AuthenticationService.ts';

export const loginLoader: LoaderFunction = async () => {
  const isLoggedIn = await authenticationService.isLoggedIn();
  if (isLoggedIn) {
    return redirect(Paths.ROOT);
  }
  return null;
};
